module.exports = __webpack_public_path__ + "img/interface OneB Mapper_1.9e582834.jpg";